<template>
  <div class="download">
    <banner img="../assets/img/appDown.jpg" title="隐私协议" />
    <div>
      <pre>
              隐私权保护声明
本站非常重视用户信息的保护，在使用本站的所有产品 和服务前，请您务必仔细阅读并透彻理解本声明。一旦 您选择使用，即表示您认可并接受本条款现有内容及其 可能随时更新的内容。
引言
本站（包括中经鑫（北京）建筑科技有限公司及其关联公司，以 下亦称“我们”）非常重视用户个人信息及隐私权的保 护， 因此我们制订了涵盖如何收集、存储、使用、共 享和保护用户信息的隐私政策。我们希望通过本本站隐 私权保护声明（“本隐私政策”）向您清晰地介绍我们对 您个人信息的处理方式，本隐私政策与您使用本站的产 品和/或服务息息相关，请您在使用本站的所有产品和/ 或服务前，完整阅读并透彻理解本隐私政策，并相应作 出您认为适当的选择。如果您不同意本隐私政策的任何 内容，您应立即停止使用本站产品和/或服务。当您使 用本站任一产品和/或服务时，则表示您同意且完全理 解本隐私政策的全部内容。
本隐私政策的适用范围
本站平台所有的产品和服务（包括本站所有的产品或服 务及未设独立隐私政策的本站关联公司的产品或服务） 均适用本隐私政策，但某些特定产品和/或服务还将适 用特定的隐私政策，我们将在向您提供这些特定产品和 /或服务前说明。
上述特定产品和/或服务的隐私政策构成本隐私政策的 一部分，如与本隐私政策有不一致之处，以特定产品和 /或服务的隐私政策为准。
除非本隐私政策另有明确所指，本隐私政策不适用于通 过我们的产品和/或服务而接入的由第三方独立为您提 供的产品和/或服务的情形，例如在搜索结果中向您显 示的产品或网站、可能包含本站服务的网站或者在我们 的服务中链接到的其他网站。 请注意，如果您使用第三 方的产品和／或服务时向其提供您的个人信息，您的信 息应当适用该第三方的隐私声明或类似政策，我们对任 何第三方不当使用或披露由您提供的信息不承担任何法 律责任。
我们可能收集的信息
为了向您提供更好、更个性化的产品和服务，您同意本站收集以下信息：
1. 您向本站提供的信息
• 1) 您注册本站帐号时须至少向我们提供帐号名称、手 机号码及或电子邮箱，并创建密码。
• 2) 您使用本站特定产品或服务时（如申请信贷、支 付、购买产品或服务、导航、建立个人主页、发表 文章等），为满足向您提供产品和服务之目的，除 注册时提供的信息外，您还需要进一步向我们提供 您的真实姓名、性别、出生日期、身份证号码、常 用地址、银行卡、头像和简介等信息，如果您不使 用特定产品和服务，则无需提供相关信息。
• 3) 我们还可能会记录您在使用我们的产品和/或服务 时提供、形成或留存的信息。例如您在使用本站搜 索时输入的搜索关键词信息和点击的链接，您在本 站百科、本站知道、本站贴吧、本站百家等平台发 布的信息，您通过本站举报、本站口碑等平台提交 的评论性信息，您在本站众测等平台提交的调研问 卷类信息，您利用本站HI等沟通软件提交的通讯信 息，您在网盘存储的信息或您参与其他产品运营活 动时提交的信息。您有权选择不提供前述信息，但 这将导致您可能无法使用特定服务或功能，或者无 法达到相关服务拟达到的效果。
• 4) 某些个人信息（如您的种族、宗教、个人健康和医 疗信息等）因其特殊性可能被认为是敏感个人信 息。您在使用我们的产品和/或服务时由您主动提 供、上传或发布的内容和信息（例如有关您社交活 动的照片等信息），可能会泄露您的敏感个人信 息，请您谨慎对待。
2. 在您使用产品或服务过程中收集的信息。
我们可能会收集关于您使用产品和/或服务（包括使用 方式）过程中的信息，此类信息包括：
1) 设备信息。为了提供更好的产品和/或服务并改善用 户体验，我们会收集设备属性信息（例如您的硬件型 号、操作系统版本、设备配置、唯一设备标识符、国际 移动设备身份码IMEI、网络设备硬件地址MAC、广告 标识符IDFA等），设备位置信息（如通过GPS、蓝牙 或WIFI信号获得的位置信息）、设备连接信息（浏览 器的类型、电信运营商、使用的语言）以及设备状态信 息（例如设备传感器数据，设备应用安装列表）。对于 从您的各种设备上收集到的信息，我们可能会将它们进 行关联，以便我们能在这些设备上为您提供一致的服 务。我们可能会将您的设备信息或电话号码与您的本站 帐户相关联。
2) 日志信息。当您使用本站的产品和/或服务时，我们 的服务器会自动记录一些信息，例如您对我们的产品和 /或服务的使用情况、IP地址、所访问服务的URL、浏 览器的类型和使用的语言、下载、安装或使用移动应用 和软件的信息、与通讯软件通讯的信息以及访问服务的 日期、时间、时长等。例如：
113.65.41.253 - - [13/Mar/2011:12:59:59 +0800] "wejianzhan.com/s?wd=测试&tn=baidu HTTP/1.1" "Mozilla/4.0"
3) 位置信息。当您使用具有定位功能的本站产品和/或 服务时，当您开启设备定位功能并使用我们基于位置提 供的相关服务时，我们可能会收集和处理有关您实际所 在位置的信息，以使得您不需要手动输入自身地理坐标 就可获得相关服务。我们会使用各种技术进行定位，这 些技术包括 IP 地址、GPS 以及能够提供相关信息的其 他传感器（比如可能会为本站提供附近设备、Wi-Fi 接 入点和基站的信息）。您可以通过关闭定位功能，停止 对您的地理位置信息的收集，但您可能将无法获得相关 服务或功能，或者无法达到相关服务拟达到的效果。
4) 唯一应用程序编号。某些产品和/或服务包含唯一应 用程序编号，当您安装、激活、更新、卸载相关产品和 /或服务或当这些产品和/或服务定期与本站通信（例如 软件的更新）时，系统会将此编号以及与安装相关的信 息（例如操作系统类型和应用程序版本号）发送给本 站。
5) 本地存储。我们可能会使用浏览器网络存储等机制 （包括HTML5）和应用数据缓存，收集您设备上的信 息并进行本地存储。
6) Cookie和匿名标示符等工具。cookie主要的功能是 便于您使用网站产品和/或服务，以及帮助网站统计独 立访客数量等。运用cookie技术，本站能够为您提供更 加周到的个性化服务，并允许您设定您特定的服务选 项。
当您使用本站产品或服务时，会向您的设备发送 cookie。当您与我们提供给合作伙伴的服务（例如广告 和/或推广服务，以及可能显示在其他网站上的由本站 提供的服务功能）进行交互时，我们允许cookie或者匿 名标识符发送给本站服务器。
您可以选择通过修改浏览器设置的方式拒绝cookie，但 您可能无法登录或使用依赖于cookie的本站服务或功 能。 如果您不希望在您访问本站联盟网站时，本站基 于cookie向您提供个性化的推广信息，可以通过个性化 配置限制本站对cookie的使用。
7) 个性化推广信息设置工具。为了在您访问联盟网站 时，向您推荐与您更相关或您更感兴趣的推广信息，可 能通过cookie记录您的偏好信息（不涉及任何指向您个 人信息）；如果您不希望联盟网站使用记录到的偏好信 息向您推荐个性化推广信息，可以通过上方按钮选择停 用，停用后联盟网站将不会再根据您的偏好信息向您推 荐个性化的推广信息。个性化配置工具只适用于您当前 使用的计算机上的当前浏览器。并且，当您删除当前浏 览器的cookie后，系统会自动重置您浏览器的个性化配 置工具设置。
以上数据信息都采用匿名的方式。同时，我们也会对信 息采取加密处理，保证信息的安全性。
3. 来自第三方的信息.
为共同向您提供产品/服务或改进产品服务的质量和个 性化程度或出于对产品和服务安全性的考量等合理需 要，我们将按照法律法规的规定或基于您的授权从关联 公司、联盟成员、合作伙伴及其他受信任的第三方供应 商、服务商及代理商处接收您的个人信息及其他信息。 我们可能如何使用收集到的信息
本站基于以下基本目的使用我们收集的信息：
1.提供和改进产品和服务。
我们使用收集的信息来提供并改进我们及我们的关联公 司、合作伙伴及其他受信任的第三方供应商、服务商及 代理商提供的产品和服务，并进行必要的业务运营，例 如运营产品或提供服务、评估、维护和改进产品或服务 的性能，参与有关我们产品和服务的市场调查活动，开 发新的产品或服务、提供客户支持等。
为改进我们及我们的关联公司、合作伙伴及其他受信任 的第三方供应商、服务商及代理商的产品和服务，本站 也可能会对产品使用情况进行统计和分析。同时，本站 可能会与公众共享这些统计信息，以展示我们服务的整 体使用趋势，但这些统计信息将不会包含您的任何身份 识别信息。
2.提供个性化产品和服务
通过使用收集的信息，本站会得以向您提供定制内容， 例如向您展现或推荐相关程度更高（而非普遍推送）的 搜索结果、信息流或者广告/推广信息结果。
我们可能会将您在某项服务中的信息与在其他本站服务 中的信息（包括个人信息）结合起来，以便更好地满足 您的个性化需求（例如使您能够获得更多个性化的推荐 内容）。
您同意授权我们与关联公司、联盟成员或其他合作伙伴 共享必要的信息以便总体上提升为您提供产品或服务的 个性化程度。
3.与您通信，并将通信内容个性化。
利用我们收集的信息，向您推荐您可能感兴趣的内容， 包括但不限于向您发出产品和服务信息，或通过系统向 您展示个性化的第三方推广信息，或者在征得您同意的 情况下与本站的关联公司、合作伙伴及其他受信任的第 三方供应商、服务商及代理商共享以便他们向您发送有 关其产品和服务的信息
我们也可能会使用信息发送重要通知，例如关于本站相 关条款、条件和政策的变更。由于这些信息对您与本站 之间的沟通至关重要，建议您接收并阅读此类信息。
4.保障合法权益
我们可能使用您的信息用于身份验证、客户服务、安全 防范、诈骗监测、信贷分析等，以预防、发现、调查欺 诈、危害安全、非法或违反与我们的协议、政策或规则 的行为，以保护您、我们的其他用户、我们或我们的关 联公司、合作伙伴及其他受信任的第三方供应商、服务 商、代理商及社会公众的合法权益。
5. 经您许可的其他用途您如何访问和更新您的信息 无论您何时使用我们的产品和/或服务，我们都会尽一 切可能保证您可以顺利访问自己的帐户内信息。如果这 些帐户注册信息有误，我们会努力提供各种方式来让您 快速更新或删除帐户内信息（除非我们出于合法业务或 法律方面的原因而必须保留这些信息）。在访问、更 新、更正和删除前述信息时，我们可能会要求您进行身 份验证，以保障您账户内信息的安全。
我们可能共享的信息本站会以高度的勤勉义务对待您的信息， 除以下情形外，未经您同意，我们不会向任何第三方共享您的 信息：
1) 为实现“我们可能如何使用收集到的信息”所列举的目 的，我们会以必要性为原则与关联公司分享您的信息， 以便总体上提升本站系产品或服务的个性化和优质程度
2) 基于您的授权，在第三方有合法、正当理由的前提 下，我们会与联盟成员、合作伙伴及其他受信任的第三 方供应商、服务商及代理商共享您的信息，以便第三方 向您提供您所需要的服务或改进服务质量和个性化程 度；
3) 履行本站相关服务协议、隐私政策及本站系产品和/ 或服务所涉用户协议及平台规则中的义务和行使我们的 权利。
我们共享您的信息时,我们会督促关联公司、联盟成 员、合作伙伴或其他受信任的第三方供应商、服务商及 代理商遵守本隐私政策并要求其采取相关的保密和安全 措施来处理上述信息。
2.如果我们或我们的关联公司涉及合并、分立、清算、 资产或业务的收购或出售等交易，您的个人信息有可能 作为此类交易的一部分而被转移，我们将确保该等信息 在转移时的机密性，并尽量确保在转移后继续受到其他 隐私权政策的约束，您同意对此予以认可和理解。
3.我们也可能为了实现以下目的，访问、使用、保留或 披露您的信息：
1) 遵循任何适用法律法规的要求、法院裁决或判决、 或政府机关的强制性要求
2) 执行适用的服务条款（包括调查可能存在的违规情 况）；
3) 查找、预防或处理欺诈、安全或技术方面的问题；
4) 在法律法规要求或允许的范围内，保护我们的客 户、我们的用户、我们或我们的关联公司、我们的雇员 或社会公众的合法权益、财产或安全免遭损害
信息安全
1.本站非常重视信息安全，本站成立了专责团队负责研 发和应用多种安全技术和程序等，通过这些严格措施努 力保护您的信息不被未经授权的访问、使用或泄漏。但 请您理解，在互联网行业由于技术的限制和飞速发展以 及可能存在的各种恶意攻击手段，即便本站竭尽所能加 强安全措施，也不可能始终保证信息的百分之百安全。 请您了解，您使用我们的产品和/或服务时所用的系统 和通讯网络，有可能因超出我们控制能力之外的其他因 素而出现安全问题。
2.如果您已经注册本站相关账号，请您使用本站提供的 密保工具服务进一步保障您的信息安全。
未成年人使用我们的产品和/或服务
本站非常重视对未成年人信息的保护。若您是18周岁 以下的未成年人，建议您请您的监护人仔细阅读本隐私 政策，并在征得您的监护人同意的前提下使用我们的产 品和/或服务或向我们提供信息。
隐私政策的修订
我们可能对本隐私政策进行不时修订，该等修订构成本 隐私政策的一部分。我们会在本页面上或通过其他我们 认为合适的方式（包括但不限于在本站合适位置发布公 告、向您发送电子邮件或以其他方式通知您）发布对本 隐私政策所做的任何变更。若您继续使用我们的产品和 /或服务，即表示您同意受修订后的本隐私政策的约 束。
附：名词解释1.设备
指可用于使用本站产品和/或服务的装置，例如桌面设 备、平板电脑或智能手机。
2.唯一设备标识符
具有唯一性的设备标识符（有时称为通用专 属 ID 或 UUID）是指由设备制造商编入到设备中的一 串字符，可用于以独有方式标识相应设备（例如国际移 动设备身份码IMEI号、网络设备硬件地址MAC、广告 标识符IDFA等）。不同的设备标识符在有效期、用户 是否可以重置以及获取方式方面会有所不同。相应设备 可能会有多个不同的具有唯一性的设备标识符。唯一设 备标识符可用于多种用途，其中包括安全性和欺诈检 测、同步服务（如用户的电子邮件收件箱）、记录用户 的偏好设置以及提供具有相关性的广告。
3.Cookie
支持服务器端（或者脚本）在客户端上存储和检索信息 的一种机制，通过增加简单、持续的客户端状态来扩展 基于Web的客户端/服务器应用。服务器在向客户端返 回HTTP对象的同时发送一条状态信息，并由客户端保 存。状态信息中说明了该状态下有效的URL范围。此 后，客户端发起的该范围内的HTTP请求都将把该状态 信息的当前值从客户端返回给服务器，这个状态信息被 称为cookie。
4.匿名标示符
本站基于设备参数，通过机器算法，生成一个标示符例 如BAIDUID、CUID，帮助本站识别一个用户，为其提 供更好的产品和/或服务与改善用户体验。
5.关联公司
指本站经营者海南捷讯嘉科技有限公司及其他与本站存 在关联关系的公司的单称或合称。“关联关系”是指对于 任何主体（包括个人、公司、合伙企业、组织或其他任 何实体）而言，即其直接或间接控制的主体，或直接或 间接控制其的主体，或直接或间接与其受同一主体控制 的主体。前述“控制”指，通过持有表决权、合约或其他 方式，直接或间接地拥有对相关主体的管理和决策作出 指示或责成他人作出指示的权力或事实上构成实际控制 的其他关系。
6.本站平台
本站提供的应用程序开发环境、快捷建站工具、网络店 铺建设工具、落地页技术服务等网站、程序、服务、工 具及客户端。

            </pre
      >
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner,
  },
};
</script>

<style lang="scss" scoped>
</style>